import axios from './utils/axios';

const IdentityService = {
  getOrganizations: async () => {
    const resp = await axios.get('/agentos/identity/organizations/');
    return resp.data;
  },
};

export default IdentityService;

